import { render, staticRenderFns } from "./LKPublicationsFormdataUploadModal.vue?vue&type=template&id=8cd5d24c&scoped=true&"
import script from "./LKPublicationsFormdataUploadModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataUploadModal.vue?vue&type=style&index=0&id=8cd5d24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd5d24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VProgressCircular,VProgressLinear})
